import { z } from 'zod';

/** Matches backend Pydantic EmailStr / email-validator rules. */
const emailSchema = z
  .string()
  .trim()
  .min(1, 'required')
  .email('invalid');

/**
 * @param {string} value
 * @returns {{ valid: true, email: string } | { valid: false, reason: 'required' | 'invalid' }}
 */
export function validateEmailAddress(value) {
  const parsed = emailSchema.safeParse(value ?? '');
  if (parsed.success) {
    return { valid: true, email: parsed.data.toLowerCase() };
  }
  const issue = parsed.error.issues[0];
  const reason = issue?.message === 'required' ? 'required' : 'invalid';
  return { valid: false, reason };
}

/** Map FastAPI/Pydantic validation errors to a single user-facing string. */
export function formatApiErrorDetail(detail, fallback = 'Request failed') {
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((item) => {
        if (typeof item === 'string') return item;
        if (item && typeof item.msg === 'string') {
          const loc = Array.isArray(item.loc) ? item.loc.filter((x) => x !== 'body').join('.') : '';
          return loc ? `${loc}: ${item.msg}` : item.msg;
        }
        return null;
      })
      .filter(Boolean);
    return parts.length ? parts.join(' ') : fallback;
  }
  return fallback;
}
